var TagListDialogModule = /** @class */ (function () {
    function TagListDialogModule() {
    }
    return TagListDialogModule;
}());
export { TagListDialogModule };
